/*
 * COPYRIGHT (c) 2023
 * HONEYWELL INC.,
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */
import React, { useEffect, useState } from 'react';
import { DataTable } from '@scuf/datatable';
import { IAny } from '../../DashboardKPIWidgets/IEnergyManagementProps';
import { Button, Checkbox, Icon, Input, Select } from '@scuf/common';
import TimeOfRangeBox from './TimeOfRangeBox';
import DaysOfWeekBox from './DaysOfWeekBox';
import moment from 'moment';

// const data = [
//   {
//     sr: '1',
//     tariffType: 'Aron Davis',
//     daysOfWeek: 'Retired',
//     timeRange: 2,
//     consumption: 12,
//     unit: 'kw',
//     action: ''
//   },
//   {
//     sr: '1',
//     tariffType: 'Aron Davis',
//     daysOfWeek: 'Retired',
//     timeRange: 2,
//     consumption: 12,
//     unit: 'kw',
//     action: ''
//   },
//   {
//     sr: '1',
//     tariffType: 'Aron Davis',
//     daysOfWeek: 'Retired',
//     timeRange: 2,
//     consumption: 12,
//     unit: 'kw',
//     action: ''
//   }
// ];

const data: IAny = [];
const formData = {
  tariffType: '',
  daysOfWeek: '',
  timeRange: '',
  consumption: '',
  cost: ''
};

const initialDaysOfWeek = {
  Monday: false,
  Tuesday: false,
  Wednesday: false,
  Thursday: false,
  Friday: false,
  Saturday: false,
  Sunday: false
};

const MangeTariffTOU = (props: IAny) => {
  const [showdaysOfWeek, setShowDaysOfWeek] = useState<boolean>(false);
  const [showSelect, setShowSelect] = useState<boolean>(false);
  const [formValue, setFormValue] = useState<IAny>(formData);
  const [dataTable, setDataTable] = useState<IAny>(props.TOUTableData);
  const [startTime, setStartTime] = useState<string>('');
  const [endTime, setEndTime] = useState<string>('');
  const [startUnit, setStartUnit] = useState<string>('');
  const [endUnit, setEndUnit] = useState<string>('');
  const [showTimeRange, setShowTimeRange] = useState<boolean>(false);
  const [timeRangeValue, setTimeRangeValue] = useState('');
  const [timeRangeOpen, setTimeRangeOpen] = useState<boolean>(false);
  const [checkedDaysOfWeek, setCheckedDaysOfWeek] = useState<IAny>(
    initialDaysOfWeek
  );
  const [daysOfWeekOpen, setDaysOfWeekOpen] = useState<boolean>(false);

  const [isDataDuplicate, setIsDataDuplicate] = useState<boolean>(false);

  const deleteTariffRow = (cellData: IAny) => {
    console.log('cellData in delete iss', cellData);
    props.setTotalConsumptionError(false);
    props.setTotalDemandError(false);
    const tempDataTable = JSON.parse(JSON.stringify(dataTable));
    tempDataTable.splice(cellData.rowIndex, 1);
    setDataTable(tempDataTable);
  };

  const ShortenDaysOfWeek: IAny = {
    Monday: 'Mon',
    Tuesday: 'Tue',
    Wednesday: 'Wed',
    Thursday: 'Thur',
    Friday: 'Fri',
    Saturday: 'Sat',
    Sunday: 'Sun'
  };

  const beautifyDaysOfWeek = (days: string) => {
    if (days && typeof days === 'string') {
      if (days.split(',').length > 1) {
        return days
          .split(',')
          .map((dy) => ShortenDaysOfWeek[dy])
          .join(',');
      } else {
        return ShortenDaysOfWeek[days];
      }
    }
    return '';
  };

  const columns: IAny = [
    {
      // className: 'SR',
      header: 'SR.',
      unit: null,
      field: 'sr',
      initialWidth: '8%'
    },
    {
      // className: 'categories',
      header: 'Tariff Type',
      unit: null,
      field: 'tariffType',
      cellDataRenderer: (cellData: IAny) => {
        return <div>{cellData.rowData.tariffType}</div>;
      },
      initialWidth: '13%'
    },
    {
      // className: 'Consumption',
      header: 'Days Of Week',
      field: 'daysOfWeek',
      cellDataRenderer: (cellData: IAny) => {
        console.log('cellData.rowData.daysOfWeek', cellData.rowData.daysOfWeek);
        return (
          <div>
            {beautifyDaysOfWeek(cellData.rowData.daysOfWeek)}
            {/* {ShortenDaysOfWeek[cellData.rowData.daysOfWeek.split(',')[0]] +
              '-' +
              ShortenDaysOfWeek[
                cellData.rowData.daysOfWeek.split(',')[
                  cellData.rowData.daysOfWeek.split(',').length - 1
                ]
              ]} */}
          </div>
        );
      },
      initialWidth: '14%'
    },
    {
      // className: 'Demand',
      header: 'Time Range',
      field: 'timeRange',
      cellDataRenderer: (cellData: IAny) => {
        return <div>{cellData.rowData.timeRange}</div>;
      },
      initialWidth: '13%'
    },
    {
      className: 'Cost',
      header: 'Consumption',
      field: 'consumption',
      cellDataRenderer: (cellData: IAny) => {
        return <div>{cellData.rowData.consumption}</div>;
      },
      initialWidth: '15%'
    },
    {
      // className: 'Cost',
      header: 'Cost',
      field: 'cost',
      cellDataRenderer: (cellData: IAny) => {
        return <div>{cellData.rowData.cost}</div>;
      },
      initialWidth: '10%'
    },
    {
      // className: 'Cost',
      header: 'Unit',
      field: 'unit',
      cellDataRenderer: (cellData: IAny) => {
        return <div>{cellData.rowData.unit}</div>;
      },
      initialWidth: '10%'
    },
    {
      // className: 'Cost',
      header: 'Action',
      field: 'action',
      cellDataRenderer: (cellData: IAny) => {
        return (
          <div
            style={props.enableTOU ? {} : { pointerEvents: 'none' }}
            onClick={() => deleteTariffRow(cellData)}
          >
            <Icon name="close" root="common" />
          </div>
        );
      },
      initialWidth: '10%'
    }
  ];

  const isDisabled = () => {
    console.log('formValue', formValue);
    console.log(
      'Object.keys(formValue).every(key=> formValue[key])',
      Object.keys(formValue).every((key) => formValue[key])
    );
    return !Object.keys(formValue).every((key) => formValue[key]);
  };

  const saveValue = (value: string, key: string) => {
    const tempformData = { ...formValue };
    tempformData[key] = value;
    setFormValue(tempformData);
  };

  const checkForTimeOverlap = (
    tableTimeRange: string,
    enteredTimeRange: string
  ) => {
    const tablesStartTime = tableTimeRange.split('-')[0];
    const tableEndTime = tableTimeRange.split('-')[1];
    const enteredStartTime = enteredTimeRange.split('-')[0];
    const enteredEndTime = enteredTimeRange.split('-')[1];
    const isStartTimeBetween = moment(enteredStartTime, 'hh:mm a').isBetween(
      moment(tablesStartTime, 'hh:mm a'),
      moment(tableEndTime, 'hh:mm a')
    );
    const isEndTimeBetween = moment(enteredEndTime, 'hh:mm a').isBetween(
      moment(tablesStartTime, 'hh:mm a'),
      moment(tableEndTime, 'hh:mm a')
    );
    if (isStartTimeBetween || isEndTimeBetween) {
      return true;
    }
    return false;
  };

  const checkForTimeMismatch = (
    tableTimeRange: string,
    enteredTimeRange: string
  ) => {
    const tablesStartTime = tableTimeRange.split('-')[0];
    const tableEndTime = tableTimeRange.split('-')[1];
    const enteredStartTime = enteredTimeRange.split('-')[0];
    const enteredEndTime = enteredTimeRange.split('-')[1];
    if (
      ((tablesStartTime.endsWith('AM') && enteredStartTime.endsWith('AM')) ||
        (tablesStartTime.endsWith('PM') && enteredStartTime.endsWith('PM'))) &&
      ((tableEndTime.endsWith('PM') && enteredEndTime.endsWith('PM')) ||
        (tableEndTime.endsWith('AM') && enteredEndTime.endsWith('AM')))
    ) {
      if (
        parseFloat(tablesStartTime.split(' ')[0]) ===
          parseFloat(enteredStartTime.split(' ')[0]) &&
        parseFloat(tableEndTime.split(' ')[0]) ===
          parseFloat(enteredEndTime.split(' ')[0])
      ) {
        return true;
      }
    }
    if (checkForTimeOverlap(tableTimeRange, enteredTimeRange)) {
      return true;
    }
    return false;
  };

  const checkForDuplicateEntry = (
    tariffType: string,
    daysOfWeek: IAny,
    timeRange: string
  ) => {
    console.log('dataTable', dataTable);
    return dataTable.some((dt: IAny) => {
      if (
        dt.tariffType === tariffType &&
        checkForTimeMismatch(dt.timeRange, timeRange)
      ) {
        let duplicatedays = false;
        daysOfWeek.split(',').forEach((day: string) => {
          // checkForTimeOverlap(tableTimeRange, enteredTimeRange)
          if (dt.daysOfWeek.split(',').includes(day)) {
            duplicatedays = true;
          }
        });
        if (duplicatedays) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    });
  };

  const addToTable = () => {
    console.log('formValue.daysOfWeek', formValue.daysOfWeek.split(','));
    if (
      checkForDuplicateEntry(
        formValue.tariffType,
        formValue.daysOfWeek,
        formValue.timeRange
      )
    ) {
      console.log('here it issss');
      setIsDataDuplicate(true);
    } else {
      console.log('');
      const tableRow = {
        sr: dataTable.length + 1,
        tariffType: formValue.tariffType,
        daysOfWeek: formValue.daysOfWeek,
        timeRange: formValue.timeRange,
        consumption: formValue.consumption,
        cost: formValue.cost,
        unit: formValue.tariffType.includes('Demand')
          ? props.utilityCellData.demandUnit
          : props.utilityCellData.consumptionUnit,
        action: ''
      };
      setFormValue(JSON.parse(JSON.stringify(formData)));
      setEndTime('');
      setStartTime('');
      setStartUnit('');
      setEndUnit('');
      setCheckedDaysOfWeek(initialDaysOfWeek);
      props.setTotalConsumptionError(false);
      props.setTotalDemandError(false);
      const tempTableData = JSON.parse(JSON.stringify(dataTable));
      tempTableData.push(tableRow);
      setDataTable(tempTableData);
      props.setTOUTableData(tempTableData);
    }
  };

  useEffect(() => {
    console.log('formValue isss***', formValue);
  }, [formValue]);

  const onDoneClick = () => {
    setIsDataDuplicate(false);
    setTimeRangeValue(
      startTime + ' ' + startUnit + '-' + endTime + ' ' + endUnit
    );
    setShowTimeRange(false);
    setTimeRangeOpen(false);
    saveValue(
      startTime + ' ' + startUnit + '-' + endTime + ' ' + endUnit,
      'timeRange'
    );
  };

  const onDaysDone = () => {
    setIsDataDuplicate(false);
    setShowDaysOfWeek(false);
    saveValue(daysOfWeekValues(), 'daysOfWeek');
    setDaysOfWeekOpen(false);
  };

  useEffect(() => {
    if (!timeRangeOpen) {
      setShowTimeRange(false);
    } else {
      setShowTimeRange(true);
    }
  }, [timeRangeOpen]);

  useEffect(() => {
    props.setTariffDetails(dataTable);
  }, [dataTable]);

  useEffect(() => {
    if (!daysOfWeekOpen) {
      setShowDaysOfWeek(false);
    } else {
      setShowDaysOfWeek(true);
    }
  }, [daysOfWeekOpen]);

  const daysOfWeekValues = () => {
    return Object.keys(checkedDaysOfWeek)
      .filter((val) => {
        if (checkedDaysOfWeek[val]) {
          return val;
        }
      })
      .join(',');
  };

  return (
    <div>
      <Checkbox
        label={'Time Of Use(TOU)'}
        className="TOU-Checkbox"
        checked={props.enableTOU}
        onChange={(checked: boolean) => {
          if (checked) {
            props.setEnableTOU(true);
          } else {
            props.setEnableTOU(false);
          }
        }}
      />
      <div className="TOU-Header-Text">
        TOU pricing is an electric rate schedule that adjusts the price of your
        electricity based on how much energy you use and when to use it.
      </div>
      <div className="Utility-TOU-Form">
        <Select
          label={'Tariff Type'}
          options={[
            { text: 'On Peak', value: 'On Peak' },
            { text: 'Off Peak', value: 'Off Peak' },
            { text: 'Demand Off Peak', value: 'Demand Off Peak' },
            { text: 'Demand On Peak', value: 'Demand On Peak' }
          ]}
          onChange={(value) => {
            setIsDataDuplicate(false);
            console.log('value iss', value);
            saveValue(value, 'tariffType');
          }}
          value={formValue.tariffType}
          disabled={!props.enableTOU}
        />
        <div className="Days-Of-Week-Parent">
          <Input
            label={'Days Of Week'}
            value={beautifyDaysOfWeek(formValue.daysOfWeek)}
            disabled={!props.enableTOU}
            className={'Days-Of-Week-Input'}
          />
          <Icon
            root="common"
            className="Days-Of-Week-Caret"
            size="small"
            style={props.enableTOU ? {} : { pointerEvents: 'none' }}
            onClick={() => {
              setDaysOfWeekOpen(!daysOfWeekOpen);
            }}
            name={daysOfWeekOpen ? 'caret-up' : 'caret-down'}
          />
          {showdaysOfWeek && props.enableTOU && (
            <DaysOfWeekBox
              setCheckedDaysOfWeek={setCheckedDaysOfWeek}
              checkedDaysOfWeek={checkedDaysOfWeek}
              setShowDaysOfWeek={setShowDaysOfWeek}
              onDaysDone={onDaysDone}
              isNewBill={props.isNewBill}
            />
          )}
        </div>

        <div className="Time-Range-Parent">
          <Input
            label={'Time Range'}
            value={formValue.timeRange}
            disabled={!props.enableTOU}
          />
          <Icon
            root="common"
            className="Time-Range-Caret"
            size="small"
            style={props.enableTOU ? {} : { pointerEvents: 'none' }}
            onClick={() => {
              setTimeRangeOpen(!timeRangeOpen);
            }}
            name={timeRangeOpen ? 'caret-up' : 'caret-down'}
          />
          {showTimeRange && props.enableTOU && (
            <TimeOfRangeBox
              startTime={startTime}
              startUnit={startUnit}
              endTime={endTime}
              endUnit={endUnit}
              setStartTime={setStartTime}
              setEndTime={setEndTime}
              setStartUnit={setStartUnit}
              setEndUnit={setEndUnit}
              onDoneClick={onDoneClick}
              isNewBill={props.isNewBill}
            />
          )}
        </div>

        <Input
          label={'Consumption'}
          className="TOU-Consumption-Input"
          onChange={(value) => {
            console.log('Consumption value iss ****', value);
            props.setTariffValueMismatch(false);
            saveValue(value, 'consumption');
          }}
          value={formValue.consumption}
          disabled={!props.enableTOU}
        />
        <Input
          label={'Cost'}
          className="TOU-Consumption-Input"
          onChange={(value) => {
            console.log('Cost value iss ****', value);
            saveValue(value, 'cost');
          }}
          value={formValue.cost}
          disabled={!props.enableTOU}
        />
        <Button
          className="TOU-ADD_Button"
          disabled={isDisabled()}
          onClick={addToTable}
          content="Add"
        />
      </div>
      <div className="Utility-TOU-Table">
        {isDataDuplicate && (
          <div className="total-error">
            {' '}
            Data already exists in Table or there is a overlap in Time range and
            /or Days Of Week
          </div>
        )}
        {props.tariffValueMismatch && (
          <div className="total-error">
            {' '}
            TOU costs are not matching with Bill Categories cost values
          </div>
        )}
        <DataTable
          data={dataTable}
          reorderableColumns={true}
          resizableColumns={true}
          className="Manage-Tariff-DataTable"
        >
          {columns.map((column: IAny) => {
            return (
              <DataTable.Column
                align={'left'}
                key={column.field}
                className={column.className}
                field={column.field}
                header={
                  column.unit
                    ? `${column.header} (${column.unit})`
                    : `${column?.header}`
                }
                //   sortable={column.sortable}
                renderer={column.cellDataRenderer}
                initialWidth={column.initialWidth}
              />
            );
          })}
        </DataTable>
      </div>
    </div>
  );
};

export default MangeTariffTOU;
